import { Component } from '@angular/core';
import { ScrollAnimateDirective } from '../../../directives/scroll-animate.directive';

@Component({
  selector: 'app-organizer-grow',
  imports: [ScrollAnimateDirective],
  templateUrl: './organizer-grow.html',
  styleUrl: './organizer-grow.css',
})
export class OrganizerGrow {}
